exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".mpbtn{padding:12px;display:block;background:#409eff;margin:auto;border:none;border-radius:10px;color:#fff;margin-top:40px;width:80%;position:absolute;top:0;left:50%;transform:translateX(-50%)}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"id":"data-v-6732b793","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/Modular/goWechat.vue
// module id = 527
// module chunks = 0